export type SystemEnvironmentType = 'production' | 'testing' | 'development'

const productionHostname = 'signmeup.studium.kit.edu'
const testingHostname = 'dev.studium.kit.edu'
const developmentHostnames = new Set(['localhost', '127.0.0.1', '::1'])
const environmentBodyClasses = [
  'environment-production',
  'environment-testing',
  'environment-development',
] as const

const getCurrentHostname = () =>
  typeof window === 'undefined' ? '' : window.location.hostname.toLowerCase()

export function getSystemEnvironmentType(hostname = getCurrentHostname()): SystemEnvironmentType {
  if (hostname === productionHostname) {
    return 'production'
  }

  if (hostname === testingHostname) {
    return 'testing'
  }

  if (developmentHostnames.has(hostname)) {
    return 'development'
  }

  return 'testing'
}

export function applySystemEnvironmentBodyClass(
  environmentType: SystemEnvironmentType,
  body = typeof document === 'undefined' ? null : document.body,
) {
  if (!body) {
    return
  }

  body.classList.remove(...environmentBodyClasses)
  body.classList.add(`environment-${environmentType}`)
}
